import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
} from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  RollbackOutlined,
} from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { API, BEARER } from '../../constant';
import ItemListDisplay from '../../components/ItemList/ItemListDispaly';
import { getToken } from '../../helpers';

import { CSVLink } from 'react-csv';
import {
  useNavigate,
  Link,
  useSearchParams,
  useLocation,
} from 'react-router-dom';

import {
  getMonthNameFromStringDate,
  compareMonth,
  sortRecordsByMonth,
} from '../../utils/dateUtils';
import moment from 'moment';

const launchNameFilterFunciton = (value, searchText) => {
  let flag = false;
  value?.launchDetails?.forEach((launch) => {
    console.log(
      launch?.launchName,
      'value - ',
      launch?.launchName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase()),
    );
    if (
      launch?.launchName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase())
    ) {
      flag = true;
    }
  });
  return flag;
};

const indentSheetFilterFunciton = (value, searchText) => {
  let flag = false;
  value?.indentSheetDetails?.forEach((indent) => {
    console.log(
      indent?.indentReffName,
      'value - ',
      indent?.indentReffName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase()),
    );
    if (
      indent?.indentReffName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase())
    ) {
      flag = true;
    }
  });
  return flag;
};

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      console.log(value);
      return (
        value?.launchDrop
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.month?.toLowerCase().includes(searchText.trim().toLowerCase()) ||
        value?.productOptionType?.productCatName
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.status
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        launchNameFilterFunciton(value, searchText) ||
        value?.status
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        indentSheetFilterFunciton(value, searchText)
      );
    });
  } else if (filterScope == 'launchDrop') {
    filteredDataTemp = Data.filter((value) => {
      return value?.launchDrop
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'launch_masters') {
    filteredDataTemp = Data.filter((value) => {
      console.log('searchValue:', searchText, value);
      return launchNameFilterFunciton(value, searchText);
    });
  } else if (filterScope == 'month') {
    filteredDataTemp = Data.filter((value) => {
      console.log('searchValue:', searchText, value);
      return value?.month
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      month: 'Not Found',
      launchDrop: 'Not Found',
      category: 'Not Found',
      quantity: 'Not Found',
      assumedMRP: 'Not Found',
      status: 'Not Found',
      launchDetails: [],
      productOptionType: {
        productCatName: 'Not Found',
        productCatRefId: 0,
      },
      indentSheetDetails: [],
    });
    return filteredDataTemp;
  }
};

const ProductOptionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [paginationData, setPaginationData] = useState({});
  // pagination object data for configuration.
  const [paginationParams, setPaginationParams] = useState(null);
  // pagination parameter changed by user

  // CSV Export
  const [downloadableData, setDownloadableData] = useState([]);
  const csvLinkRef = useRef();

  const [isLoading, setIsLoading] = useState(null);
  const [isDownloading, setIsDownloading] = useState(null);

  const authToken = getToken();
  const [Data, setData] = useState([]);
  const [indentList, setIndentList] = useState([]);
  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');
  const [isIndentModalOpen, setIsIndentModalOpen] = useState(false);

  const [filterScope, setFilterScope] = useState('all');

  const filterScopeOptionsArray = [
    'all',
    'launchDrop',
    'month',
    'launch_masters',
  ];

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);

  const searchPageParam = searchParams?.get('page');
  const searchQueryParam = searchParams?.get('searchquery');
  const currentPage = parseInt(searchPageParam, 10) || 1;
  const searchString = searchQueryParam || '';
  const [searchText, setSearchText] = useState(searchString || null);

  console.log(location, location.state, '58');
  console.log(alreadySelectedRows, '59');
  // not used

  console.log(
    'search parametere received',
    searchParams.get('launchNo'),
    searchParams.get('page'),
    searchParams.get('searchquery'),
    searchPageParam,
    searchQueryParam,
    currentPage,
    searchString,
  );

  let searchPLaunch =
    location.state ??
    (searchParams?.get('launchNo') ? searchParams.get('launchNo') : '');
  console.log(searchPLaunch, location.state, '197');
  let filterParam = '';
  if (searchPLaunch) {
    filterParam = searchPLaunch
      ? `filters[$and][0][launch_masters][id][$eq]=${searchPLaunch}`
      : '';
  }
  console.log(filterParam, 'filter param string query');

  const toPreviousPage = () => {
    navigate(-1);
  };

  const toProductOptionDetails = (state) => {
    navigate('/productOptionDetails', { state });
  };

  let data1 = [];

  const getUserdDetailsCreatedBy = async (entry, contentTypeName) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=${contentTypeName}&filters[$and][0][activity][$eq]=create&filters[$and][0][resourceId][$eq]=${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      },
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Resouce Details',
      entry?.id,
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const fetchDataAll = async (token) => {
    setIsDownloading(true);
    const requestedAdditionalDetails = {
      //not used
      populate: ['launch_master', 'product_option_types', 'indent_sheets'],

      filters: {
        //only used
        all: searchText?.trim()?.toLowerCase() ?? '',

        launch_master: { launchName: 'July 2 Launch' },
        product_option_types: {
          productType: 'shirt',
        },
      },
      sort: {
        createdAt: 'desc',
      },
    };
    const data = { data: { requestedAdditionalDetails } };
    try {
      const response = await fetch(`${API}/product-option/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData, 'response check fetch all');
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        data1 = await Promise.all(
          responseData?.data?.completeSuccess?.map((entry) => {
            console.log('entry object in Fetch all function', entry);
            // Fetch User Details
            // const userDetails = await getUserdDetailsCreatedBy(
            //   entry,
            //   'product-options'
            // );
            // End Fetch User Details
            const userDetails = {
              userRefId: entry?.userDetails[0]?.user?.userID,
              userName: entry?.userDetails[0]?.user?.username,
              userEmail: entry?.userDetails[0]?.user?.email,
            };

            let launchObj = [];
            if (entry?.launch_masters?.length > 0) {
              // console.log(entry.launch_masters);
              launchObj = entry?.launch_masters?.map((launchMasterObject) => {
                console.log(launchMasterObject);
                return {
                  launchRefId: launchMasterObject?.id,
                  launchName: launchMasterObject?.launchName,
                  launchCategory: launchMasterObject?.launchCat,
                  launchMonth: launchMasterObject?.launchMonth,
                  launchDrop: launchMasterObject?.launchDrop,
                  launchDate: launchMasterObject?.launchDate,
                  seasonDetails: {
                    seasonId: launchMasterObject?.season?.season_id,
                    seasonRefId: launchMasterObject?.season?.id,
                  },
                };
              });
            }

            let indentSheetsObjArray = [];
            if (entry?.indent_sheets?.length > 0) {
              // console.log(entry.indent_sheets);
              indentSheetsObjArray = entry.indent_sheets?.map(
                (indentSheetObject) => {
                  console.log(indentSheetObject);
                  return {
                    indentRefId: indentSheetObject?.id,
                    indentReffName: indentSheetObject?.Indent_file_reference_id,
                    indentRefLink: indentSheetObject?.Indent_file_link,
                    indentDate: indentSheetObject?.indent_file_date,
                    indentType: indentSheetObject?.indent_type,
                  };
                },
              );
            }

            let productOptionTypeObject = {};
            if (entry?.product_option_type) {
              let productOptionType = entry?.product_option_type;
              productOptionTypeObject = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                productCatRefId: productOptionType?.id,
                productCatName: productOptionType?.productCategoryName,
              };
            }

            //   let productOptionList = [];
            //   if (entry?.attributes.product_option_qties?.data?.length > 0) {
            //
            //     productOptionList = entry.attributes.product_option_qties?.data.map(
            //       (productOptionQtyObject) => {
            //         let productOptionObject =
            //           productOptionQtyObject.attributes.product_option_type;
            //         let poqId = productOptionQtyObject.id;
            //         let quantity = productOptionQtyObject.attributes.quantity;
            //         let poObject = {
            //           productCatName:
            //             productOptionObject.data.attributes.productCategoryName,
            //           productCatId: productOptionObject.data.id,
            //         };

            //         return { poqId, quantity, poObject };
            //       }
            //     );
            //   }

            return {
              key: entry?.id,
              id: entry?.id,
              month: entry?.month,
              launchDrop: entry?.launchDrop,
              category: productOptionTypeObject?.productCatName,
              quantity: entry?.qty,
              assumedMRP: entry?.assumedMRP,
              launchDetails: launchObj,
              productOptionType: productOptionTypeObject,
              indentSheetDetails: indentSheetsObjArray,
              status: entry?.status,
              userDetails: userDetails,
              createdAt: entry?.createdAt,
              updatedAt: entry?.updatedAt,
            };
          }),
        );

        console.log('original Data fetch all:', responseData);
        console.log('current Data after modification fetch all:', data1);
        // setData(await sortRecordsByMonth(data1));
        const finalDownloadData = data1;
        console.log('final filtered data fetch all:', finalDownloadData);
        return finalDownloadData;
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsDownloading(false);
    }
  };

  const fetchData = async (token, additionalData = '') => {
    setIsLoading(true);
    try {
      //  ${
      //     location?.state && `&filters[otb_record][id][$eq]=${location?.state}`
      //   }
      // can be modified  : additionalData?.currentPageNew || currentPage
      const paginationParameter = `pagination[page]=${
        additionalData?.currentPageNew || currentPage
      }&pagination[pageSize]=${10}&pagination[withCount]=true`;
      const queryString = [
        `populate[launch_masters][populate][season]=true`,
        `populate[product_option_type]=true`,
        `populate[indent_sheets]=true`,
        paginationParameter,
        filterParam,
        additionalData?.searchParameters,
        `sort=id:desc`,
      ]
        .filter(Boolean)
        .join('&');

      console.log(
        'search and other option functionality',
        additionalData,
        'query : ',
        `${API}/product-options?${queryString}`,
      );
      const response = await fetch(`${API}/product-options?${queryString}`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const responseData = await response.json();
      console.log(responseData, 'response check');
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        setPaginationData(responseData?.meta?.pagination);
        // setSearchParams({ page: current });

        // return;

        data1 = await Promise.all(
          responseData?.data?.map(async (entry) => {
            // Fetch User Details
            const userDetails = await getUserdDetailsCreatedBy(
              entry,
              'product-options',
            );
            // End Fetch User Details

            let launchObj = [];
            if (entry?.attributes?.launch_masters?.data?.length > 0) {
              // console.log(entry.attributes.launch_masters?.data);
              launchObj = entry.attributes.launch_masters?.data?.map(
                (launchMasterObject) => {
                  console.log(launchMasterObject);
                  return {
                    launchRefId: launchMasterObject?.id,
                    launchName: launchMasterObject?.attributes?.launchName,
                    launchCategory: launchMasterObject?.attributes?.launchCat,
                    launchMonth: launchMasterObject?.attributes?.launchMonth,
                    launchDrop: launchMasterObject?.attributes?.launchDrop,
                    launchDate: launchMasterObject?.attributes?.launchDate,
                    seasonDetails: {
                      seasonId:
                        launchMasterObject?.attributes?.season?.data?.attributes
                          ?.season_id,
                      seasonRefId:
                        launchMasterObject?.attributes?.season?.data?.id,
                    },
                  };
                },
              );
            }

            let indentSheetsObjArray = [];
            if (entry?.attributes?.indent_sheets?.data?.length > 0) {
              // console.log(entry.attributes.indent_sheets?.data);
              indentSheetsObjArray = entry.attributes.indent_sheets?.data?.map(
                (indentSheetObject) => {
                  console.log(indentSheetObject);
                  return {
                    indentRefId: indentSheetObject?.id,
                    indentReffName:
                      indentSheetObject?.attributes?.Indent_file_reference_id,
                    indentRefLink:
                      indentSheetObject?.attributes?.Indent_file_link,
                    indentDate: indentSheetObject?.attributes?.indent_file_date,
                    indentType: indentSheetObject?.attributes?.indent_type,
                  };
                },
              );
            }

            let productOptionTypeObject = {};
            if (entry?.attributes?.product_option_type) {
              let productOptionType = entry?.attributes?.product_option_type;
              productOptionTypeObject = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                productCatRefId: productOptionType?.data?.id,
                productCatName:
                  productOptionType?.data?.attributes?.productCategoryName,
              };
            }

            //   let productOptionList = [];
            //   if (entry?.attributes.product_option_qties?.data?.length > 0) {
            //
            //     productOptionList = entry.attributes.product_option_qties?.data.map(
            //       (productOptionQtyObject) => {
            //         let productOptionObject =
            //           productOptionQtyObject.attributes.product_option_type;
            //         let poqId = productOptionQtyObject.id;
            //         let quantity = productOptionQtyObject.attributes.quantity;
            //         let poObject = {
            //           productCatName:
            //             productOptionObject.data.attributes.productCategoryName,
            //           productCatId: productOptionObject.data.id,
            //         };

            //         return { poqId, quantity, poObject };
            //       }
            //     );
            //   }

            return {
              key: entry?.id,
              id: entry?.id,
              month: entry?.attributes?.month,
              launchDrop: entry?.attributes?.launchDrop,
              category: productOptionTypeObject?.productCatName,
              quantity: entry?.attributes?.qty,
              assumedMRP: entry?.attributes?.assumedMRP,
              launchDetails: launchObj,
              productOptionType: productOptionTypeObject,
              indentSheetDetails: indentSheetsObjArray,
              status: entry?.attributes?.status,
              userDetails: userDetails,
              createdAt: entry?.attributes?.createdAt,
              updatedAt: entry?.attributes?.updatedAt,
            };
          }),
        );

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);
        // setData(await sortRecordsByMonth(data1));
        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const getSearchParameters = () => {
    let searchParameters = '';

    let sanitizedSearchText = searchText?.trim()?.toLowerCase() ?? '';
    if (filterParam) {
      searchParameters = `filters[$and][1][$or][0][launchDrop][$containsi]=${sanitizedSearchText}&filters[$and][1][$or][1][month][$containsi]=${sanitizedSearchText}&filters[$and][1][$or][2][launch_masters][launchName][$containsi]=${sanitizedSearchText}&filters[$and][1][$or][3][product_option_type][productCategoryName][$containsi]=${sanitizedSearchText}&filters[$and][1][$or][4][indent_sheets][Indent_file_reference_id][$containsi]=${sanitizedSearchText}&filters[$and][1][$or][5][id][$eq]=${sanitizedSearchText}&filters[$and][1][$or][6][launch_masters][season][season_id][$containsi]=${sanitizedSearchText}`;
    } else {
      if (!searchText) {
        return searchParameters;
      }
      searchParameters = `filters[$or][0][launchDrop][$containsi]=${sanitizedSearchText}&filters[$or][1][month][$containsi]=${sanitizedSearchText}&filters[$or][2][launch_masters][launchName][$containsi]=${sanitizedSearchText}&filters[$or][3][product_option_type][productCategoryName][$containsi]=${sanitizedSearchText}&filters[$or][4][indent_sheets][Indent_file_reference_id][$containsi]=${sanitizedSearchText}&filters[$or][5][id][$eq]=${sanitizedSearchText}&filters[$or][6][launch_masters][season][season_id][$containsi]=${sanitizedSearchText}`;
    }

    return searchParameters;
  };

  const updateSearchText = (searchTextReceived) => {
    setSearchText(searchTextReceived);
  };

  useEffect(() => {
    if (authToken) {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    }
  }, []);

  useEffect(() => {
    console.log(
      'pagination parameters updated',
      paginationParams,
      paginationData,
    );
    if (paginationParams) {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    } else {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    }
  }, [paginationParams]);

  useEffect(() => {
    console.log(searchText);
    if (paginationData?.page) {
      setSearchParams({
        page: paginationData?.page,

        ...(searchText && { searchquery: searchText }),
      });
    }
  }, [paginationData]);

  useEffect(() => {
    console.log(
      'search param change',
      searchText,
      currentPage,
      paginationData,
      paginationParams,
    );
    if (searchText === '') {
      console.log('search empty', searchText);
      setSearchParams({
        page: 1,
        ...(searchPLaunch && { launchNo: searchPLaunch }),
      });
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
    } else if (searchText) {
      let searchParameters = getSearchParameters();
      setSearchParams({
        ...(currentPage ? { page: currentPage } : { page: 1 }),
        ...(searchText && { searchquery: searchText }),
        ...(searchPLaunch && { launchNo: searchPLaunch }),
      });
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
    }
  }, [searchText, filterScope]);

  const showIndentModal = (record) => {
    console.log('this is inside showIndentModal', record);
    setIndentList(
      record?.indentSheetDetails?.map((indent) => indent?.indentReffName),
    );

    setIsIndentModalOpen(true);
  };

  const handleIndentOk = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsIndentModalOpen(false);
  };
  const handleIndentCancel = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsIndentModalOpen(false);
  };
  // if (isLoading) {
  //   return <Spin size="large" />;
  // }

  const columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
    },
    {
      key: 'month',
      title: 'Month',
      dataIndex: 'month',
    },
    {
      key: 'season',
      title: 'Season',
      render: (_, record) => {
        return record?.launchDetails[0]?.seasonDetails?.seasonId;
      },
    },
    {
      key: 'launchDrop',
      title: 'Launch Drop',
      dataIndex: 'launchDrop',
    },
    {
      key: 'launch',
      title: 'Launch Details',
      render: (_, record) => {
        return record?.launchDetails[0]?.launchName;
      },
    },
    {
      key: 'category',
      title: 'Sub Category',
      dataIndex: 'category',
    },
    {
      key: 'IndentSheetDetails',
      title: 'Indent Sheets',
      render: (_, record) => {
        console.log('recode check indent', record);
        return record?.indentSheetDetails?.map((indentInfo) => {
          return (
            <li onClick={() => showIndentModal(record)}>
              {indentInfo?.indentReffName}
            </li>
          );
        });

        // return record?.indentSheetDetails?.indentReffName;
      },
    },
    {
      key: 'quantity',
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      key: 'assumedMRP',
      title: 'Assumed MRP',
      dataIndex: 'assumedMRP',
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'createdAt',
      title: 'Created-Date',
      dataIndex: 'createdAt',
      render: (_, record) => {
        // console.log(record, record?.userDetails?.userName);
        return moment(record?.createdAt).format('DD/MM/YYYY') ?? 'NA';
      },
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (_, record) => {
        switch (record?.status) {
          case 'confirmed':
            return 'confirmed';
            break;
          case 'core_prod_generated':
            return 'Core Product Generated';
            break;
          default:
            return record?.status;
            break;
        }
      },
    },
    {
      key: 'action',
      title: 'Actions',

      render: (_, record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />
              <Button
                disabled={record?.status === 'core_prod_generated'}
                icon={
                  <DeleteOutlined style={{ color: 'red', marginRight: 8 }} />
                }
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteRecord = async (recordID) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/product-options/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        let searchParameters = getSearchParameters();
        fetchData(authToken, { searchParameters });
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteRecord(record?.id);
      },
    });
  };

  const Edit = (record) => {
    toProductOptionDetails(record);
    //navigate to new page
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    // return;
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
    const { current } = pagination;
    setPaginationParams({
      page: pagination?.current,
      pageCount: Math.ceil(pagination?.total / pagination?.pageSize) ?? 0,
      pageSize: pagination.pageSize,
      total: pagination.total,
    });
    setSearchParams({
      page: current,
      ...(searchText && { searchquery: searchText }),
      ...(searchPLaunch && { launchNo: searchPLaunch }),
    });
  };

  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText('');
    setFilterScope('all');
    setAlreadySelectedRows([]);
    fetchData(authToken);
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  }; // change in filter scope selected by user

  const getFilterOptionArray = (options) => {
    return options?.map((option) => {
      return { value: option, label: option };
    });
  }; //

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const confirmAllselectedRecords = async () => {
    console.log(alreadySelectedRows, 'confirm all selected records func');
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/product-option/confirm-product-option`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            data: { selectedProductOptionRecords: alreadySelectedRows },
          }),
        },
      );
      const responseData = await response.json();
      console.log(responseData);

      if (responseData?.error) {
        if (responseData?.errorInfo?.status == 403) {
          message.error(
            'Unable to Process your Request, ' + responseData?.error,
          );
        } else {
          message.error('Something went wrong, please try again');
        }
      } else {
        message.success('All Selected Records are confirmed Successfully');
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const otbRecordStatusLookupObject = {
    active: 'Active',
    inactive: 'Inactive',
    wip: 'Wip',
    complete: 'Complete',
    dropped: 'Dropped',
    deleted: 'Deleted',
    confirmed: 'Confirmed',
    core_prod_generated: 'Product Generated',
  };
  const getDisplayableStatus = (sys_status) => {
    return otbRecordStatusLookupObject[sys_status];
  };

  // console.log(fetchDataAll(authToken), '---logging---');

  const getFinalFormatedData = async () => {
    const finalDownloadableData = await getFormattedData();
    setDownloadableData(finalDownloadableData);
    setTimeout(() => {
      csvLinkRef?.current?.link?.click(); // Manually trigger CSV download
    }, 600); // Small delay to ensure state update
  };

  const getFormattedData = async () => {
    const downloadData = await fetchDataAll(authToken);
    console.log(downloadData, 'downloading data...');

    let downloadDataFormatted = downloadData?.map((row, index) => {
      console.log(row, 'downloading data row...', index);
      return {
        ID: row?.id,
        Month: row?.month,
        Season: row?.launchDetails[0]?.seasonDetails?.seasonId,
        'Launch Drop': row?.launchDrop,
        'Launch Name': row?.launchDetails
          .map((launch) => launch?.launchName)
          .join(','),
        Quantity: row?.quantity,
        'Assumed MRP': row?.assumedMRP,

        'Product Option Type': row?.productOptionType?.productCatName,
        'Indent Attached': row?.indentSheetDetails
          .map((indentSheetObj) => indentSheetObj?.indentRefLink)
          .join(','),
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
        status: getDisplayableStatus(row?.status),
      };
    });

    console.log(downloadDataFormatted, 'downloading data 2...');
    if (downloadDataFormatted?.length > 0) {
      return downloadDataFormatted;
    } else {
      return [
        {
          ID: 0,
          Month: 'Not Found',
          Season: 'Not Found',
          'Launch Drop': 'Not Found',
          'Launch Name': 'Not Found',
          Quantity: 'Not Found',
          'Assumed MRP': 'Not Found',
          'Product Option Type': 'Not Found',
          'Indent Attached': 'Not Found',
          userName: 'Not Found',
          CreatedDate: 'Not Found',
          status: 'Not Found',
        },
      ];
    }
  };

  const generateCoreProductForAllselectedRecords = async () => {
    console.log(
      alreadySelectedRows,
      'gen core product all selected records func',
    );
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/product-option/generate-developmentProduct`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify({
            data: { selectedProductOptionRecords: alreadySelectedRows },
          }),
        },
      );
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        if (responseData?.data?.incompleteSuccess?.length > 0) {
          message.warn('completed with error for some Product Options');
        } else {
          message.success('completed core Product generation');
        }

        fetchData(getToken());
        // resetTable();
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h2>Product Option Listing</h2>
        {/* Back Button*/}
        <Button type="link" onClick={toPreviousPage}>
          Back
          <RollbackOutlined />
        </Button>
      </div>

      <Button
        onClick={() => {
          toProductOptionDetails();
        }}
      >
        Add Product Option
      </Button>

      {/* Table Section */}
      <div className="table">
        {/* Filter search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button
              onClick={() => {
                filterParam = '';
                resetTable();
              }}
            >
              Reset
            </Button>
            <Button
              style={{ backgroundColor: 'greenyellow', color: 'white' }}
              onClick={getFinalFormatedData}
            >
              Download {isDownloading && <Spin size="small" />}
            </Button>
            <CSVLink
              data={downloadableData}
              filename={
                'Product-Option-list-' + moment(new Date()).format('DD-MM-YYYY')
              }
              ref={csvLinkRef}
              style={{ display: 'none' }}
            />
          </div>
        </div>

        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{
              current: currentPage,
              pageSize: paginationData?.pageSize,
              total: paginationData?.total,
              position: ['bottomCenter'],
            }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              getCheckboxProps: (record) => ({
                disabled: record.status === 'core_prod_generated',
                // Column configuration not to be checked
              }),
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [
                Table.SELECTION_NONE,
                Table.SELECTION_ALL,

                {
                  key: 'confirmSelected',
                  text: 'Confirm All Selected Rows',
                  onSelect: (allkeys) => {
                    console.log('confirmSelected');
                    confirmAllselectedRecords();
                  },
                },
                {
                  key: 'ConfirmCreateCoreProduct',
                  text: 'Confirm and Create Core Product',
                  onSelect: (allkeys) => {
                    console.log('confirmSelected');
                    generateCoreProductForAllselectedRecords();
                  },
                },
              ],
            }}
          />
        )}
      </div>
      <Modal
        title="Indents List"
        // open={isIndentModalOpen}
        visible={isIndentModalOpen}
        onOk={handleIndentOk}
        onCancel={handleIndentCancel}
      >
        <ul>
          {indentList.map((indentReffName) => (
            <li key={indentReffName}>{indentReffName}</li>
          ))}
        </ul>
      </Modal>
    </div>
  );
};

// const IndentModel = (content) => {
//   <Modal
//     title="Indents List"
//     // open={isIndentModalOpen}
//     visible={isIndentModalOpen}
//     onOk={handleIndentOk}
//     onCancel={handleIndentCancel}
//   >
//     <ul>
//       <li>content1</li>
//       <li>content2</li>
//       <li>content3</li>
//     </ul>
//   </Modal>;
// };

export default ProductOptionList;
